export const BannersTrackers = {
  actions: {
    clickOnBanner: 'Clicou no Banner da Home',
    clickOnQuotationBanner: 'Clicou no Banner de Cotação',
  },
}
